module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "services view"
  }, [_c('nks-header'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "v-transition-main-views"
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0b92e5a0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services.vue
// module id = 61
// module chunks = 0